import { IValidationRule } from "@/types"

const shippingOrderCartManualPositionValidationRules: { [s: string]: IValidationRule } = {
    description: {
        required: true
    },
    measurementSystemId: {
        required: true
    },
    dimension1: {
        type: "decimal",
        min: 0
    },
    dimension2: {
        type: "decimal",
        min: 0
    },
    dimension3: {
        type: "decimal",
        min: 0
    },
    weight: {
        type: "decimal",
        min: 0
    },
}

export default shippingOrderCartManualPositionValidationRules
